import { ReactNode } from 'react';

export type ContentWrapperProps = {
  children: ReactNode;
};

export const ContentWrapper = ({ children }: ContentWrapperProps) => (
  <div className="position-relative w-100">{children}</div>
);
